export const THEME_COLORS = {
  black: '#000000',
  blue: '#009ee3',
  blueLow: '#009ee333',
  blueMedium: '#009ee366',
  blueHigh: '#009ee3b3',
  green: '#00ae5e',
  greenLow: '#00ae5e33',
  greenMedium: '#00ae5e66',
  greenHigh: '#00ae5eb3',
  orange: '#f68932',
  orangeLow: '#f6893233',
  orangeMedium: '#f6893266',
  orangeHigh: '#f68932b3',
  pink: '#ef5299',
  pinkLow: '#ef529933',
  pinkMedium: '#ef529966',
  pinkHigh: '#ef5299b3',
  primary: '#009ee3',
  primaryLow: '#009ee333',
  primaryMedium: '#009ee366',
  primaryHigh: '#009ee3b3',
  red: '#c94a5b',
  redLow: '#c94a5b33',
  redMedium: '#c94a5b66',
  redHigh: '#c94a5bb3',
  white: '#ffffff',
  yellow: '#ffd533',
  yellowLow: '#ffd53333',
  yellowMedium: '#ffd53366',
  yellowHigh: '#ffd533b3',
  success: '#00ae5e',
  successLow: '#00ae5e33',
  successMedium: '#00ae5e66',
  successHigh: '#00ae5eb3',
  danger: '#c94a5b',
  dangerLow: '#c94a5b33',
  dangerMedium: '#c94a5b66',
  dangerHigh: '#c94a5bb3',
  grayLight: '#a0abb2',
  grayLightLow: '#a0abb233',
  grayLightMedium: '#a0abb266',
  grayLightHigh: '#a0abb2b3',
  grayMedium: '#485966',
  grayMediumLow: '#48596633',
  grayMediumMedium: '#48596666',
  grayMediumHigh: '#485966b3',
  grayDark: '#1c1c1b',
  grayDarkLow: '#1c1c1b33',
  grayDarkMedium: '#1c1c1b66',
  grayDarkHigh: '#1c1c1bb3',
};

export type ThemeColor = keyof typeof THEME_COLORS;

export function isThemeColor(value: string): value is ThemeColor {
  return Object.keys(THEME_COLORS).includes(value);
}

export const THEME_COLORS_SECONDARY = {
  blue: THEME_COLORS.blue,
  green: THEME_COLORS.green,
  orange: THEME_COLORS.orange,
  pink: THEME_COLORS.pink,
  red: THEME_COLORS.red,
  yellow: THEME_COLORS.yellow,
};
